// extracted by mini-css-extract-plugin
export default {"wrapper":"s-64NxSUdfqU7Y3a+06cqw==","inputContainer":"-MFFA-R47Zs578d4GYzRyA==","textInput":"ZSCV0HuutvbyXFeV7vhAdw==","label":"_406aVqUuv553LoUnGl4Jsw=="};